import {inject, Injectable, Signal} from '@angular/core';

import {StatisticsService} from '@intocare/statistics';

@Injectable({
	providedIn: 'root'
})
export class StatisticsFacadeService {
	private statisticsService = inject(StatisticsService);

	getAllStatisticsQueryOptions(date: Signal<string>) {
		return this.statisticsService.getAllStatisticsQueryOptions(date);
	}
}
